export default {
	attributes: {
		align: 'full',
		design: 'wave-1',
		height: 200,
		flipVertically: false,
		flipHorizontally: false,
		layer1Width: 1,
		layer1Flip: false,
		layer1Shadow: false,
		layer2: false,
		layer2Height: 1,
		layer2Width: 1,
		layer2Flip: false,
		layer2Opacity: 0.5,
		layer3: false,
		layer3Height: 1,
		layer3Width: 1,
		layer3Flip: false,
		layer3Opacity: 0.5,
		uniqueClass: 'ugb-0a56cba',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
	},
}
